import { useEffect } from 'react';
import useUserProfile from './useUserProfile';

const useFlutterCallHandler = (init, userType) => {
  const { userProfile } = useUserProfile();

  useEffect(() => {
    if (!init) {
      return;
    }

    window.top?.flutter_inappwebview?.callHandler?.(
      'profile_setUser',
      JSON.stringify({
        firstName: userProfile?.attributes?.firstName,
        lastName: userProfile?.attributes?.lastName,
        profileImageUrl: userProfile?.attributes?.avatar,
        userId: userProfile?.id,
        userType,
      }),
    );
  }, [init, userProfile, userType]);

  const handleLogout = () => {
    window.top?.flutter_inappwebview?.callHandler?.('profile_setUser', null);
  };

  return { handleLogout };
};

export default useFlutterCallHandler;
